<template>
  <div class="alipay-container">
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-s-order"></i> 展会订单列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="alipay-card" shadow="never">
      <!-- 搜索区域 -->
      <div class="search-bar">
        <el-form :model="searchForm" size="small" label-width="70px" label-position="right">
          <el-row :gutter="16">
            <el-col :span="6">
              <el-form-item label="订单号">
                <el-input 
                  v-model="searchForm.order_no" 
                  placeholder="请输入订单编号"
                  prefix-icon="el-icon-search"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="展商名称">
                <el-input 
                  v-model="searchForm.company_name" 
                  placeholder="展商/企业名称"
                  prefix-icon="el-icon-user"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="展会">
                <el-select
                  v-model="searchForm.expo_id"
                  placeholder="选择展会"
                  clearable
                >
                  <el-option
                    v-for="item in expoList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="支付状态">
                <el-select
                  v-model="searchForm.pay_status"
                  placeholder="全部支付状态"
                  clearable
                >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="待支付" :value="0"></el-option>
                  <el-option label="已支付" :value="1"></el-option>
                  <el-option label="已退款" :value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="下单时间">
                <el-date-picker
                  v-model="searchForm.date_range"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  clearable
                  style="width:100%"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="search-actions">
              <el-button type="primary" @click="searchSubmit" icon="el-icon-search">搜索</el-button>
              <el-button @click="resetSearch" icon="el-icon-refresh-right">重置</el-button>
              <el-button type="success" @click="addOrder" icon="el-icon-plus">新建订单</el-button>
              <el-button type="warning" @click="exportData" icon="el-icon-download">导出订单</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card" @click="filterPay('all')">
          <div class="stat-icon total"><i class="el-icon-s-order"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ totalCount }}</div>
            <div class="stat-label">全部订单</div>
          </div>
        </div>
        <div class="stat-card" @click="filterPay(0)">
          <div class="stat-icon pending"><i class="el-icon-time"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ waitPayCount }}</div>
            <div class="stat-label">待支付</div>
          </div>
        </div>
        <div class="stat-card" @click="filterPay(1)">
          <div class="stat-icon approved"><i class="el-icon-check"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ paidCount }}</div>
            <div class="stat-label">已支付</div>
          </div>
        </div>
        <div class="stat-card" @click="filterPay(2)">
          <div class="stat-icon rejected"><i class="el-icon-refresh-left"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ refundCount }}</div>
            <div class="stat-label">线下核销</div>
          </div>
        </div>
      </div>

      <!-- 订单表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableData"
          stripe
          border
          size="mini"
          row-key="id"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
        >
          <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column label="订单信息" min-width="200">
            <template slot-scope="scope">
              <div class="shop-info">
                <div class="shop-name">
                  <i class="el-icon-s-order"></i>
                  <span>订单号：{{ scope.row.order_no }}</span>
                </div>
                <div class="shop-sn">
                  <span class="label">创建时间：</span>
                  <span class="value">{{ scope.row.create_time | dateFormat }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="展会信息" min-width="160">
            <template slot-scope="scope">
              <div class="address-info">
                <span>{{ scope.row.expo.title || '-' }}</span>
              </div>
              <div class="address-info">
                <span>{{ scope.row.expo.start_time | dateFormat }} ~ {{ scope.row.expo.end_time | dateFormat }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="展商信息" min-width="160">
            <template slot-scope="scope">
              <div class="shop-info">
                <div class="shop-name">{{ scope.row.company_name }}</div>
                <div class="shop-sn">手机号：{{ scope.row.mobile }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="展位明细" min-width="220">
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                width="300"
                trigger="hover"
                :content="getBoothText(scope.row.orderbooth)"
              >
                <span slot="reference" class="booth-tag">
                  共{{ scope.row.orderbooth.length }}个展位
                </span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="展位总面积" width="100" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" type="primary" effect="plain">
                {{ scope.row.total_area }} ㎡
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="订单总金额" width="120" align="center">
            <template slot-scope="scope">
              <span class="money-text">￥{{ scope.row.total_amount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="预付金额" width="120" align="center">
            <template slot-scope="scope">
              ￥{{ scope.row.prepay_amount }}
            </template>
          </el-table-column>
          <el-table-column label="支付方式" width="110" align="center">
            <template slot-scope="scope">
              {{ scope.row.pay_type == 1 ? '微信支付' : '线下转账' }}
            </template>
          </el-table-column>
          <el-table-column label="支付状态" width="110" align="center">
            <template slot-scope="scope">
              <el-tag :type="getPayTagType(scope.row.pay_status)" size="small" effect="dark">
                {{ getPayText(scope.row.pay_status) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="业务员" width="120" align="center">
            <template slot-scope="scope">
              {{ scope.row.seller?.name_cn || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="170" align="center" fixed="right">
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="handleCommand($event, scope.row)">
                <el-button type="primary" size="mini" plain>
                  更多操作 <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="view"><i class="el-icon-view"></i> 订单详情</el-dropdown-item>
                  <el-dropdown-item command="edit" v-if="scope.row.pay_status == 0"><i class="el-icon-edit"></i> 修改订单</el-dropdown-item>
                  <el-dropdown-item command="pay" v-if="scope.row.pay_status == 0"><i class="el-icon-wallet"></i> 发起支付</el-dropdown-item>
                  <el-dropdown-item command="refund" v-if="scope.row.pay_status == 1"><i class="el-icon-refresh-left"></i> 申请退款</el-dropdown-item>
                  <el-dropdown-item command="print"><i class="el-icon-printer"></i> 打印订单</el-dropdown-item>
                  <el-dropdown-item command="del" v-if="scope.row.pay_status == 0"><i class="el-icon-delete"></i> 删除订单</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-wrapper" style="margin-top:20px;text-align:right;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10,20,50,100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>

      <!-- 空数据 -->
      <div v-if="tableData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-s-order"></i>
        <p>暂无订单数据</p>
        <el-button type="primary" size="small" @click="addOrder">新建订单</el-button>
      </div>
    </el-card>

    <!-- 订单详情弹窗 -->
    <el-dialog title="订单详情" :visible.sync="detailDialog" width="700px" :close-on-click-modal="false" class="alipay-dialog">
      <div v-if="currentRow">
        <p>订单号：{{ currentRow.order_no }}</p>
        <p>展商：{{ currentRow.company_name }} / 手机：{{ currentRow.mobile }}</p>
        <p>展会：{{ currentRow.expo.title }}</p>
        <p>总金额：￥{{ currentRow.total_amount }} | 预付：￥{{ currentRow.prepay_amount }}</p>
        <p>支付状态：{{ getPayText(currentRow.pay_status) }}</p>
        <h4>选购展位：</h4>
        <el-table :data="currentRow.orderbooth" border size="mini">
          <el-table-column label="展位编号" prop="booth_sn"></el-table-column>
          <el-table-column label="面积" prop="area"></el-table-column>
          <el-table-column label="单价" prop="amount"></el-table-column>
          <el-table-column label="状态">
            <template slot-scope="s">
              {{ s.occupied ? '已占用' : '可使用' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailDialog = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: "expoOrderList",
  data() {
    return {
      loading: false,
      // 统计
      totalCount: 0,
      waitPayCount: 0,
      paidCount: 0,
      refundCount: 0,
      // 下拉选项
      expoList: [],
      // 搜索表单
      searchForm: {
        order_no: "",
        company_name: "",
        expo_id: "",
        pay_status: "",
        date_range: []
      },
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      // 弹窗
      detailDialog: false,
      currentRow: null
    }
  },
  filters: {
    dateFormat(timestamp) {
      if (!timestamp) return '--'
      return moment(timestamp * 1000).format('YYYY-MM-DD')
    }
  },
  created() {
    //this.getExpoSelect()
    this.getOrderList()
  },
  methods: {
    headerCellStyle() {
      return { background: '#f5f7fa', color: '#1f2d3d', fontWeight: '500', fontSize: '14px', borderBottom: '1px solid #e4e7ed' }
    },
    rowStyle() { return { cursor: 'pointer' } },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // 支付状态标签
    getPayTagType(status) {
      if (status == 0) return 'warning'
      if (status == 1) return 'success'
      if (status == 2) return 'danger'
      return 'info'
    },
    getPayText(status) {
      if (status == 0) return '待支付'
      if (status == 1) return '已支付'
      if (status == 2) return '线下核销'
      return '未知'
    },
    // 展位hover文本
    getBoothText(list) {
      if (!list || list.length == 0) return '无展位'
      return list.map(item => `展位${item.booth_sn} 面积${item.area}㎡`).join('、')
    },
    // 统计计算
    calcStat() {
      let total = 0, wait = 0, paid = 0, refund = 0
      this.tableData.forEach(item => {
        total++
        if (item.pay_status == 0) wait++
        else if (item.pay_status == 1) paid++
        else if (item.pay_status == 2) refund++
      })
      this.totalCount = total
      this.waitPayCount = wait
      this.paidCount = paid
      this.refundCount = refund
    },
    // 状态卡片筛选
    filterPay(val) {
      this.searchForm.pay_status = val
      this.searchSubmit()
    },
    // 获取展会下拉
    getExpoSelect() {
      let param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token')
      }
      this.$axios.getExpoSelect(param).then(res => {
        if (res.code == 200) this.expoList = res.data
      })
    },
    // 获取订单列表
    getOrderList() {
      this.loading = true
      let param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        proxy_id: sessionStorage.getItem('proxy_id'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        order_no: this.searchForm.order_no,
        company_name: this.searchForm.company_name,
        expo_id: this.searchForm.expo_id,
        pay_status: this.searchForm.pay_status,
        start_date: this.searchForm.date_range[0] || '',
        end_date: this.searchForm.date_range[1] || ''
      }
      this.$axios.findExpoOrderListP(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableData = res.data.data
          this.total = res.data.total
          this.calcStat()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('网络请求失败')
      })
    },
    // 搜索
    searchSubmit() {
      this.pageNum = 1
      this.getOrderList()
    },
    // 重置
    resetSearch() {
      this.searchForm = {
        order_no: "",
        company_name: "",
        expo_id: "",
        pay_status: "",
        date_range: []
      }
      this.searchSubmit()
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.getOrderList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.getOrderList()
    },
    // 下拉操作
    handleCommand(cmd, row) {
      switch (cmd) {
        case 'view':
          this.currentRow = row
          this.detailDialog = true
          break
        case 'edit':
          this.$router.push({ path: '/order/form', query: { id: row.id } })
          break
        case 'pay':
          this.$router.push({ path: '/order/pay', query: { id: row.id } })
          break
        case 'refund':
          this.$confirm('确认发起退款？').then(() => {
            this.$axios.orderRefund({ id: row.id }).then(r => {
              if (r.code == 200) {
                this.$message.success('退款申请成功')
                this.getOrderList()
              }
            })
          })
          break
        case 'print':
          window.open(`/admin/order/print?id=${row.id}`)
          break
        case 'del':
          this.$confirm('删除后不可恢复，确认删除？', '警告', { type: 'warning' }).then(() => {
            this.$axios.delOrder({ id: row.id }).then(r => {
              if (r.code == 200) {
                this.$message.success('删除成功')
                this.getOrderList()
              }
            })
          })
          break
      }
    },
    addOrder() {
      this.$router.push('/expoOrderForm')
    },
    exportData() {
      const params = { ...this.searchForm }
      params.company_id = sessionStorage.getItem('company_id')
      window.open(this.$axios.baseUrl + '/admin/order/export?' + new URLSearchParams(params))
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}
.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}
.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 20px 24px; }
}
.search-bar {
  background: #f8f9fc;
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  .el-form-item { margin-bottom: 16px; width: 100%; }
  .el-form-item__label { font-size: 12px; padding-right: 8px; font-weight: 500; color: #606266; }
  .el-input ::v-deep .el-input__inner,
  .el-select ::v-deep .el-input__inner,
  .el-date-picker ::v-deep .el-input__inner {
    border-radius: 20px;
  }
  .search-actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: -4px;
    .el-button {
      border-radius: 20px;
      padding: 8px 18px;
    }
    .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; border-color: #4096ff; } }
    .el-button--success { background: #00b578; border-color: #00b578; &:hover { background: #1acd8c; border-color: #1acd8c; } }
    .el-button--warning { background: #ff7d00; border-color: #ff7d00; }
  }
}
.stat-cards {
  display: flex; gap: 20px; margin-bottom: 24px; flex-wrap: wrap;
  .stat-card {
    flex: 1; min-width: 160px; background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px; padding: 20px; display: flex; align-items: center; gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04); transition: all 0.3s ease; cursor: pointer;
    &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); }
    .stat-icon { width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; color: #fff; }
    .stat-info { .stat-value { font-size: 28px; font-weight: 700; color: #1f2d3d; line-height: 1.2; } .stat-label { font-size: 13px; color: #8c8f98; margin-top: 4px; } }
    .total { background: linear-gradient(135deg, #1677ff, #4096ff); }
    .pending { background: linear-gradient(135deg, #e6a23c, #ebb563); }
    .approved { background: linear-gradient(135deg, #00b578, #1acd8c); }
    .rejected { background: linear-gradient(135deg, #ff4d4f, #ff7875); }
  }
}
.table-wrapper { margin-bottom: 20px; min-height: 350px; }
.el-table { border-radius: 12px; overflow: hidden; &::before { display: none; } th { background: #fafbfc !important; font-weight: 500; } td { border-bottom: 1px solid #f0f0f0; } .el-table__row { transition: background 0.2s; &:hover { background: #f8f9fc; } } }
.shop-info {
  .shop-name { display: flex; align-items: center; gap: 8px; margin-bottom: 4px; i { font-size: 16px; color: #1677ff; } span { font-weight: 500; } }
  .shop-sn { .label { font-size: 12px; color: #8c8f98; } .value { font-size: 12px; color: #1677ff; font-family: monospace; } }
}
.address-info {
  font-size: 12px; color: #666; line-height: 1.5;
}
.booth-tag {
  color: #1677ff; cursor: pointer;
}
.money-text {
  color: #f56c6c; font-weight: bold;
}
.empty-state { text-align: center; padding: 60px 20px; color: #c0c4cc; i { font-size: 64px; } p { margin-top: 16px; font-size: 14px; } .el-button { margin-top: 20px; border-radius: 20px; } }
.alipay-dialog .el-dialog {
  border-radius: 20px; overflow: hidden; box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  .el-dialog__header { background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%); padding: 20px 24px; .el-dialog__title { color: #fff; font-size: 18px; font-weight: 500; } }
  .el-dialog__body { padding: 24px; }
  .el-dialog__footer { padding: 16px 24px 24px; border-top: 1px solid #f0f0f0; }
}
.dialog-footer {
  display: flex; justify-content: flex-end; gap: 12px;
  .el-button { border-radius: 24px; padding: 9px 24px; }
  .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; border-color: #4096ff; } }
}
.pagination-wrapper {
  ::v-deep .el-pagination {
    .el-pager li { border-radius: 4px; }
    .btn-next,.btn-prev { border-radius: 4px; }
  }
}
@media (max-width: 1200px) {
  .search-bar .search-actions { margin-top: 0; justify-content: flex-start; flex-wrap: wrap; }
}
</style>